import { render, staticRenderFns } from "./riesgosModificable.vue?vue&type=template&id=787804a4&scoped=true&"
import script from "./riesgosModificable.vue?vue&type=script&lang=js&"
export * from "./riesgosModificable.vue?vue&type=script&lang=js&"
import style0 from "./riesgosModificable.vue?vue&type=style&index=0&id=787804a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787804a4",
  null
  
)

export default component.exports